import { render, staticRenderFns } from "./otherTable.vue?vue&type=template&id=61723d38&scoped=true"
import script from "./otherTable.vue?vue&type=script&lang=ts"
export * from "./otherTable.vue?vue&type=script&lang=ts"
import style0 from "./otherTable.vue?vue&type=style&index=0&id=61723d38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61723d38",
  null
  
)

export default component.exports